'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface ViewControlsProps {
  viewMode: 'grid' | 'list';
  onViewModeChange: (mode: 'grid' | 'list') => void;
  sortBy: string;
  onSortChange: (sort: string) => void;
  totalResults: number;
  onToggleMobileFilters: () => void;
}

const ViewControls = ({
  viewMode,
  onViewModeChange,
  sortBy,
  onSortChange,
  totalResults,
  onToggleMobileFilters,
}: ViewControlsProps) => {
  const sortOptions = [
    { value: 'popularity', label: 'Most Popular' },
    { value: 'rating', label: 'Highest Rated' },
    { value: 'newest', label: 'Newest First' },
    { value: 'price-low', label: 'Price: Low to High' },
    { value: 'price-high', label: 'Price: High to Low' },
  ];

  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6">
      <div className="flex items-center gap-4 w-full sm:w-auto">
        <button
          onClick={onToggleMobileFilters}
          className="lg:hidden flex items-center gap-2 px-4 py-2 bg-card border border-border rounded-lg text-foreground hover:bg-muted transition-colors"
        >
          <Icon name="AdjustmentsHorizontalIcon" size={20} variant="outline" />
          <span className="text-sm font-medium">Filters</span>
        </button>

        <div className="text-sm text-muted-foreground">
          <span className="font-semibold text-foreground">{totalResults}</span> courses found
        </div>
      </div>

      <div className="flex items-center gap-4 w-full sm:w-auto">
        <div className="flex items-center gap-2">
          <label htmlFor="sort-select" className="text-sm text-muted-foreground whitespace-nowrap">
            Sort by:
          </label>
          <select
            id="sort-select"
            value={sortBy}
            onChange={(e) => onSortChange(e.target.value)}
            className="px-3 py-2 bg-card border border-border rounded-lg text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-primary cursor-pointer"
          >
            {sortOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>

        <div className="hidden sm:flex items-center gap-1 bg-card border border-border rounded-lg p-1">
          <button
            onClick={() => onViewModeChange('grid')}
            className={`p-2 rounded transition-colors ${
              viewMode === 'grid' ?'bg-primary text-white' :'text-muted-foreground hover:text-foreground hover:bg-muted'
            }`}
            aria-label="Grid view"
          >
            <Icon name="Squares2X2Icon" size={20} variant="outline" />
          </button>
          <button
            onClick={() => onViewModeChange('list')}
            className={`p-2 rounded transition-colors ${
              viewMode === 'list' ?'bg-primary text-white' :'text-muted-foreground hover:text-foreground hover:bg-muted'
            }`}
            aria-label="List view"
          >
            <Icon name="ListBulletIcon" size={20} variant="outline" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewControls;